<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.monthPlan.new')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <!-- <li class="breadcrumb-item">
                        <router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link>
                    </li> -->
                    <li class="breadcrumb-item">
                        <router-link to="/prd/monthPlan"><span>{{$t('tlt.monthPlan')}}</span></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/monthPlan/edit"><span>{{$t('tlt.monthPlan.new')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('monthPlan')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('monthPlan')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row"> 
                            <!-- <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.monthPlan.code')}}:</label>
                                <input v-validate="'required'" name="code"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('code') }"
                                    v-model="code" type="text">
                                <span v-show="errors.has('code')" class="lbl-obg">
                                    {{ errors.first('code') }}
                                </span>
                            </div>  -->

                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.monthPlan.locId')}}:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="planLocation">
                                </dimSearch>                                
                            </div>  

                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.monthPlan.locName')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="planLocation">
                                </dimSearch>                                
                            </div>

                            <div class="form-group col-md-2" >
                                    <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.monthPlan.month')}}：</label>
                                    <mmf-monthpicker      v-model="month"></mmf-monthpicker>
                            </div> 

                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.monthPlan.matId')}}:</label>
                                <dimSearch  validate="required" name="matId"
                                            v-model="matId" :entity="materials" submitProp="id" bindProp="id" bindId="planMaterial">
                                </dimSearch>                                
                            </div> 
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.monthPlan.matName')}}:</label>
                                <dimSearch  validate="required" name="matName"
                                            v-model="matName" :entity="materials" submitProp="matName" bindProp="matName" bindId="planMaterial">
                                </dimSearch>                                
                            </div>
                        
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.monthPlan.output')}}:</label>
                                <input v-validate="'required'" name="output"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('output') }"
                                    v-model="output" type="text">
                                <span v-show="errors.has('output')" class="lbl-obg">
                                    {{ errors.first('output') }}
                                </span>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.monthPlan.operationRate')}}:</label>
                                <input class="form-control form-control-sm" v-model="operationRate" type="text">
                            </div>  
                        </div>
                        <div class="row">
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeId1')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeId1"
                                            v-model="qualitySpeId1" :entity="qualitySpe" submitProp="id" bindProp="id" bindId="qualitySpe1" unEdit="true">
                                </dimSearch>                                
                            </div> 
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeCode1')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeCode1"
                                            v-model="qualitySpeCode1" :entity="qualitySpe" submitProp="code" bindProp="code" bindId="qualitySpe1" >
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeUpLimit1')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeUpLimit1"
                                            v-model="qualitySpeUpLimit1" :entity="qualitySpe" submitProp="upLimit" bindProp="upLimit" bindId="qualitySpe1" unEdit="true">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeLowLimit1')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeLowLimit1"
                                            v-model="qualitySpeLowLimit1" :entity="qualitySpe" submitProp="lowLimit" bindProp="lowLimit" bindId="qualitySpe1" unEdit="true">
                                </dimSearch>                                
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeId2')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeId2"
                                            v-model="qualitySpeId2" :entity="qualitySpe" submitProp="id" bindProp="id" bindId="qualitySpe2" unEdit="true">
                                </dimSearch>                                
                            </div> 
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeCode2')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeCode2"
                                            v-model="qualitySpeCode2" :entity="qualitySpe" submitProp="code" bindProp="code" bindId="qualitySpe2"> 
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeUpLimit2')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeUpLimit2"
                                            v-model="qualitySpeUpLimit2" :entity="qualitySpe" submitProp="upLimit" bindProp="upLimit" bindId="qualitySpe2" unEdit="true">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg"></span>{{$t('lbl.monthPlan.qualitySpeLowLimit2')}}:</label>
                                <dimSearch  validate="required" name="qualitySpeLowLimit2"
                                            v-model="qualitySpeLowLimit2" :entity="qualitySpe" submitProp="lowLimit" bindProp="lowLimit" bindId="qualitySpe2" unEdit="true">
                                </dimSearch>                                
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.monthPlan.status')}}:</label>
                                <input class="form-control form-control-sm" v-model="status" type="text">
                            </div>                        
                        </div> -->
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>



<script>
    import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,
        mapState
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionPlan/MonthPlan";
    import dimSearch from "@/components/MMFDimSearch";
    import MmfMonthpicker from '@/components/MmfMonthpicker';

    const {
        mapFields
    } = createHelpers({
        getterType: 'monthPlan/getField',
        mutationType: 'monthPlan/updateField',
    });
    export default {
        data() {
            return {
                         
            }
        },
        beforeMount() {
            this.$store.dispatch('monthPlan/loadLocations');
            this.$store.dispatch('monthPlan/loadMaterials');
            this.$store.dispatch('monthPlan/loadQualitySpe');
        },
        computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.monthPlan.locations,
                materials: state => state.monthPlan.materials,
                qualitySpe: state => state.monthPlan.qualitySpe,
            }),          
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            dimSearch,
            MmfMonthpicker
        }
    };
</script>